export default __webpack_public_path__ + "static/media/placeholder-conversation.df59bf59.svg";